module.exports = __webpack_public_path__ + "img/6.71ad92a6.svg";